// @ts-nocheck
/*
 * Port of views/dashboard/ivr/IVR/ivr_view.js (75 lines).
 * BYTE-IDENTICAL.
 *
 * V1 QUIRKS preserved:
 *  - v1 imports from `react-flow-renderer` (a v10 fork), NOT `reactflow`.
 *    Package is unmaintained. v2 uses `@xyflow/react` — the CustomNode
 *    default-export `Handle`/`Position`/`Background`/`Controls`/`MiniMap`
 *    surface is compatible.
 *  - v1 HARDCODES a UUID literal ('607454cf-df31-46f5-92c6-f9bb0e0ab513')
 *    as the IVR id when calling `API_IVR_VIEW.replace(':id', …)`.
 *    Kept verbatim — this file is dead-shipped (not the real "view"
 *    surface used by IVR List's Edit/View actions) and would 404 for
 *    every caller anyway. Fixing it would drift from the source.
 */
import React, { useState, useEffect } from 'react';
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  Handle,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { getApiCall } from '@/service/httpCall';
import { API_IVR_VIEW } from '@/service/url';
import { useParams } from 'react-router-dom';

const CustomNode = ({ data }: any) => {
  return (
    <div
      style={{
        paddingRight: '14px',
        border: '1px solid black',
        borderRadius: '4px',
        backgroundColor: 'white',
      }}
    >
      <Handle type="target" position={'top' as any} />
      <div dangerouslySetInnerHTML={{ __html: data.htmlContent }} />
      <Handle type="source" position={'bottom' as any} />
    </div>
  );
};

const nodeTypes = {
  customNode: CustomNode,
};

const IVRView = () => {
  const [nodes, setNodes] = useState<any[]>([]);
  const [edges, setEdges] = useState<any[]>([]);
  const { cid } = useParams();

  useEffect(() => {
    const apiIvrViewUrl = API_IVR_VIEW.replace(':cid', cid).replace(
      ':id',
      '607454cf-df31-46f5-92c6-f9bb0e0ab513',
    );
    getApiCall(apiIvrViewUrl).then(onIvrViewSuccess).catch(onError);
  }, []);

  function onIvrViewSuccess(resp: any) {
    transformNodes(resp);
    setEdges(resp.edgeData.edgeJson);
  }

  function onError(err: any) {
    console.log(err);
  }

  const transformNodes = (nodesArray: any) => {
    const nodes: any[] = [];
    nodesArray.nodesData.forEach((item: any) => {
      nodes.push(item.flowRender);
    });

    setNodes(nodes);
    return nodes;
  };

  return (
    <div style={{ height: '50vh', width: '100%', position: 'relative' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView
      >
        <MiniMap />
        <Controls />
        <Background />
      </ReactFlow>
    </div>
  );
};

export default IVRView;
